// REQ-VAL-01 — hex de 6 dígitos, fallback si no matchea
const HEX_REGEX = /^#[0-9A-Fa-f]{6}$/;

export function sanitizeColor(value: string | null | undefined, fallback: string): string {
  if (!value || !HEX_REGEX.test(value)) return fallback;
  return value;
}
